import React from 'react';
import BaseVegetableCharacter from './BaseVegetableCharacter.jsx';

const CarrotCharacter = (props) => {
    // Carrot-specific colors
    const primaryColor = "#f58634";
    const secondaryColor = "#e67e22";

    // Carrot-specific body rendering function
    const renderCarrotBody = (bodyRef) => (
        <>
            {/* Carrot Body */}
            <mesh castShadow>
                <coneGeometry args={[0.25, 0.8, 16]} />
                <meshStandardMaterial color={primaryColor} />
            </mesh>

            {/* Carrot Greens */}
            <group position={[0, 0.4, 0]}>
                {[...Array(5)].map((_, i) => {
                    const angle = (i / 5) * Math.PI * 2;
                    const x = Math.sin(angle) * 0.05;
                    const z = Math.cos(angle) * 0.05;
                    return (
                        <mesh key={i} position={[x, 0.1, z]} rotation={[0.4, angle, 0]} castShadow>
                            <cylinderGeometry args={[0.01, 0.01, 0.25, 8]} />
                            <meshStandardMaterial color="#2d6a4f" />
                        </mesh>
                    );
                })}
            </group>
        </>
    );

    return (
        <BaseVegetableCharacter
            {...props}
            renderBody={renderCarrotBody}
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
        />
    );
};

export default CarrotCharacter;
